export default __webpack_public_path__ + "static/media/about-image.f82c659c.png";